import { ifDefined, } from '@tymia/shared';
import { parse, } from 'content-disposition';
import { nonEmptyString, } from '../../validator.js';
export const clientInvoiceModuleUrl = import.meta.url;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function clientInvoiceDownloadTanRequestSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            token: nonEmptyString(),
        },
        required: [
            'token',
        ],
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function clientInvoiceDownloadTanResponseSchema() {
    return {
        oneOf: [
            {
                type: 'object',
                additionalProperties: false,
                properties: {
                    status: {
                        const: 'ok',
                    },
                    phone: nonEmptyString(),
                },
                required: [
                    'status',
                    'phone',
                ],
            },
            {
                type: 'object',
                additionalProperties: false,
                properties: {
                    status: {
                        const: 'error',
                    },
                    reason: {
                        type: 'string',
                        enum: [
                            'invalid token',
                            'country code missing',
                            'invalid phone number',
                            'too many tans requested',
                            'rate limited',
                        ],
                    },
                },
                required: [
                    'status',
                    'reason',
                ],
            },
        ],
    };
}
export async function clientInvoiceDownloadRequestTan(baseUrl, props) {
    const result = await fetch(`${baseUrl}/api/client/invoice/download/request-tan`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(props),
    });
    if (result.status === 200) {
        return await result.json();
    }
    if (result.status === 400) {
        // TODO: validate
        return await result.json();
    }
    return {
        status: 'network error',
        httpStatus: result.status,
        message: await result.text(),
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function clientInvoiceDownloadInvoiceRequestSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            token: nonEmptyString(),
            tan: nonEmptyString(),
        },
        required: [
            'token',
            'tan',
        ],
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function clientInvoiceDownloadInvoiceResponseSchema() {
    return {
        oneOf: [
            {
                type: 'object',
                additionalProperties: false,
                properties: {
                    status: {
                        const: 'ok',
                    },
                },
                required: [
                    'status',
                ],
            },
            {
                type: 'object',
                additionalProperties: false,
                properties: {
                    status: {
                        const: 'error',
                    },
                    reason: {
                        type: 'string',
                        enum: [
                            'invalid credentials',
                        ],
                    },
                },
                required: [
                    'status',
                    'reason',
                ],
            },
        ],
    };
}
export async function clientInvoiceDownloadInvoice(baseUrl, { action, ...props }) {
    const query = action ? `?action=${action}` : '';
    const response = await fetch(`${baseUrl}/api/client/invoice/download/invoice${query}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(props),
    });
    const contentType = response.headers.get('Content-Type');
    if (contentType?.includes('application/json')) {
        if (response.status === 200) {
            return await response.json();
        }
        if (response.status === 400) {
            // TODO: validate
            return await response.json();
        }
        return {
            status: 'network error',
            httpStatus: response.status,
            message: await response.text(),
        };
    }
    const contentDisposition = response.headers.get('Content-Disposition');
    const fileName = ifDefined(contentDisposition, parse)
        ?.parameters.filename ?? 'Rechnung.pdf';
    return {
        status: 'file',
        file: await response.blob(),
        fileName,
    };
}
//# sourceMappingURL=ClientInvoiceApi.js.map